import { render } from "./SignAndSubmitModal.vue?vue&type=template&id=451fab0b&ts=true"
import script from "./SignAndSubmitModal.vue?vue&type=script&lang=ts"
export * from "./SignAndSubmitModal.vue?vue&type=script&lang=ts"

import "./SignAndSubmitModal.vue?vue&type=style&index=0&id=451fab0b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__